/*
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.58
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The AqaCellColours model module.
 * @module model/AqaCellColours
 * @version v0
 */
export default class AqaCellColours {
  /**
   * Constructs a new <code>AqaCellColours</code>.
   * @alias module:model/AqaCellColours
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>AqaCellColours</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/AqaCellColours} obj Optional instance to populate.
   * @return {module:model/AqaCellColours} The populated <code>AqaCellColours</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new AqaCellColours();
      if (data.hasOwnProperty('overall'))
        obj.overall = ApiClient.convertToType(data['overall'], 'String');
      if (data.hasOwnProperty('population'))
        obj.population = ApiClient.convertToType(data['population'], 'String');
      if (data.hasOwnProperty('uniqueness'))
        obj.uniqueness = ApiClient.convertToType(data['uniqueness'], 'String');
      if (data.hasOwnProperty('number'))
        obj._number = ApiClient.convertToType(data['number'], 'String');
      if (data.hasOwnProperty('date'))
        obj._date = ApiClient.convertToType(data['date'], 'String');
      if (data.hasOwnProperty('string'))
        obj._string = ApiClient.convertToType(data['string'], 'String');
      if (data.hasOwnProperty('type'))
        obj.type = ApiClient.convertToType(data['type'], 'String');
      if (data.hasOwnProperty('native'))
        obj._native = ApiClient.convertToType(data['native'], 'String');
    }
    return obj;
  }
}

/**
 * Allowed values for the <code>overall</code> property.
 * @enum {String}
 * @readonly
 */
AqaCellColours.OverallEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaCellColours.OverallEnum} overall
 */
AqaCellColours.prototype.overall = undefined;

/**
 * Allowed values for the <code>population</code> property.
 * @enum {String}
 * @readonly
 */
AqaCellColours.PopulationEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaCellColours.PopulationEnum} population
 */
AqaCellColours.prototype.population = undefined;

/**
 * Allowed values for the <code>uniqueness</code> property.
 * @enum {String}
 * @readonly
 */
AqaCellColours.UniquenessEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaCellColours.UniquenessEnum} uniqueness
 */
AqaCellColours.prototype.uniqueness = undefined;

/**
 * Allowed values for the <code>_number</code> property.
 * @enum {String}
 * @readonly
 */
AqaCellColours.NumberEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaCellColours.NumberEnum} _number
 */
AqaCellColours.prototype._number = undefined;

/**
 * Allowed values for the <code>_date</code> property.
 * @enum {String}
 * @readonly
 */
AqaCellColours.DateEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaCellColours.DateEnum} _date
 */
AqaCellColours.prototype._date = undefined;

/**
 * Allowed values for the <code>_string</code> property.
 * @enum {String}
 * @readonly
 */
AqaCellColours.StringEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaCellColours.StringEnum} _string
 */
AqaCellColours.prototype._string = undefined;

/**
 * Allowed values for the <code>type</code> property.
 * @enum {String}
 * @readonly
 */
AqaCellColours.TypeEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaCellColours.TypeEnum} type
 */
AqaCellColours.prototype.type = undefined;

/**
 * Allowed values for the <code>_native</code> property.
 * @enum {String}
 * @readonly
 */
AqaCellColours.NativeEnum = {
  /**
   * value: "red"
   * @const
   */
  red: "red",

  /**
   * value: "amber"
   * @const
   */
  amber: "amber",

  /**
   * value: "green"
   * @const
   */
  green: "green"
};
/**
 * @member {module:model/AqaCellColours.NativeEnum} _native
 */
AqaCellColours.prototype._native = undefined;

